/*eslint no-useless-escape: 0*/
interface IReviewStarsProps {
  averageRating: number;
  UNSAFE_className?: string;
}

const ReviewStars: React.FC<IReviewStarsProps> = ({
  averageRating,
  UNSAFE_className = '',
}) => {
  const allStars = [...Array(5).keys()];

  return (
    <div className={`container ${UNSAFE_className}`}>
      {allStars.map((index) => {
        const fill = Math.min(1, Math.max(0, averageRating - index)) * 100;

        return (
          <div className="parent" key={index}>
            <div className="star" />
            <div style={{ width: `${fill}%` }} className="star-full" />
          </div>
        );
      })}
      <style jsx>{`
        .container {
          width: 101px;
          height: 17px;
        }

        .parent {
          display: inline-block;
          position: relative;
          margin-right: var(--space-1);
          height: 17px;
        }
        .parent:last-child {
          margin-right: 0;
        }

        .star {
          display: inline-block;
          width: 17px;
          height: 17px;
          background: url('/icons/empty-star.svg');
        }
        .star-full {
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 17px;
          height: 17px;
          background: url('/icons/full-star.svg');
        }
      `}</style>
    </div>
  );
};

export default ReviewStars;
